import styled from 'styled-components';

import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const StickySectionTitle = styled.a`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--unit);
  background: var(--c-black);
  top: 0;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(-1 * var(--double-unit));
    height: var(--double-unit);
    background: linear-gradient(
      180deg,
      var(--c-black) 0%,
      var(--c-black) 20%,
      transparent 100%
    );
  }
  z-index: 1;
  @media ${laptopAndAbove} {
    width: 270px;
    min-height: 100px;
    top: calc(var(--current-stack-height) + var(--unit));
    &:after {
      content: none;
    }
  }
  position: sticky;
  &,
  &:hover,
  &:focus {
    color: var(--c-white);
  }
`;
